(function() {

	var trackingData = $(document.body).attr("data-track");

	var trackFbEvent = function(event, data) {
		if (typeof fbq !== "undefined") {
			fbq('track', event, data);	
		}
	}

	if (trackingData) {
		trackingData = JSON.parse(trackingData);

		var facebookData = trackingData["fb"];

		if (facebookData) {
			var event = facebookData.event;
			var data  = facebookData.data || null;

			trackFbEvent(event, data);
		}
	}

	CartItems.on("add", function(item) {

		var data = {
			value: item.promo_price && item.promo_price < item.price ? item.promo_price : item.price,
			currency: "BGN",
			content_ids: [ item.id ],
			contents: [{
				id: item.id,
				quantity: 1,
				item_price: item.promo_price && item.promo_price < item.price ? item.promo_price : item.price
			}],
			content_type: "product",
			content_name: item.title,
			content_category: item.category.name
		};

		trackFbEvent("AddToCart", data);
	});


	// GA CODE
	function createFunctionWithTimeout(callback, opt_timeout) {
		var called = false;

		function fn() {
			if (!called) {
				called = true;
				callback();
			}
		}

		setTimeout(fn, opt_timeout || 1000);
		return fn;
	}

	var trackImpressions = function(parent, lists) {
		var listName = '';
		var listId = '';

		if (!lists) {
			if (parent) {
				var lists = $(parent).find("[data-product-list]");
			} else {
				var lists = $("[data-product-list]");
			}
		} else {
			listName = $(parent).attr("data-product-list");
			listId = $(parent).attr("data-product-list-id");
		}

		var impressionsAdded = 0;

		lists.each(function(ind, list) {
			var $list = $(list);

			if ($list.attr("data-product-list") && $list.attr("data-product-list-id")) {
				listName = $list.attr("data-product-list");
				listId = $list.attr("data-product-list-id");
			}
			
			var ga4Items = [];

			$list.find("[data-ga]").each(function() {
				var itemProps = $(this).attr("data-ga");
				
				if (itemProps)
				{
					itemProps = JSON.parse(itemProps);
					
					ga4Items.push({
						item_id: itemProps.id,
						item_name: itemProps.name,
						currency: "BGN",
						discount: parseFloat(itemProps.discount).toFixed(2),
						index: itemProps.position,
						item_brand: itemProps.brand,
						item_category: itemProps.category,
						price: itemProps.base_price,
						quantity: 1
					}); 

					itemProps.list = listName;

					if (!$(this).closest(".swiper-slide-duplicate").length) {
						// Push google analytics event
						if (typeof ga !== "undefined") {
							ga("ec:addImpression", itemProps);
						}

						impressionsAdded++;

						if (impressionsAdded > 15) {
							trackEcommerceHit();
							impressionsAdded -= 15;
						}
					}

					var productLink = $(this).attr("data-product-link") ? $(this) : $(this).find("[data-product-link]");

					productLink.on("click", function(e) {
						// Do nothing if GALoaded is not loaded
						if (!window.GALoaded) {
							return;
						}

						e.preventDefault();

						var href = $(this).attr("href");

						ga("ec:addProduct", itemProps);

						ga("ec:setAction", "click", {
							"list": listName
						});

						ga("send", "event", "Product click", listName, itemProps.name, {
						    hitCallback: function() {
						      document.location = href;
						    }
						});
					});
				}
			});

			// Push google tag event
			if (typeof gtag !== "undefined") {
				gtag("event", "view_item_list", {
					item_list_id: listId,
					item_list_name: listName,
					items: ga4Items
				});
			}

			// Push data layer event
			if (typeof dataLayer !== "undefined") {
				dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
				dataLayer.push({
					event: "view_item_list", 
					ecommerce: {
						item_list_id: listId,
						item_list_name: listName,
						items: ga4Items
					}
				});
			}
		});

	}

	var trackDetail = function() {
		$product = $("[data-product-detail]");
		var data = $product.attr("data-ga");

		if (data) {
			data = JSON.parse(data);

			// Push google analytics event
			if (typeof ga !== "undefined") {
				ga("ec:addProduct", data);
				ga("ec:setAction", "detail");
			}

			// Push google tag event
			if (typeof gtag !== "undefined") {
				gtag('event', 'view_item', {
					currency: "BGN",
					value: data.price,
					items: [
					{
						item_id: data.id,
						item_name: data.name,
						currency: "BGN",
						discount: data.discount,
						item_brand: data.brand,
						item_category: data.category,
						price: data.base_price,
						quantity: 1,
						id: data.id,
						google_business_vertical: 'custom'
					}
					]
				});
			}

			// Push data layer event
			if (typeof dataLayer !== "undefined") {
				dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'view_item', 
					ecommerce: {
						currency: "BGN",
						value: data.price,
						items: [
						{
							item_id: data.id,
							item_name: data.name,
							discount: data.discount,
							item_brand: data.brand,
							item_category: data.category,
							price: data.base_price,
							quantity: 1,
							id: data.id,
							google_business_vertical: 'custom'
						}
						]
					}
				});
			}
		}
	}

	var trackProductAdd = function(item) {
		// Push google analytics events
		if (typeof ga !== "undefined") {
			ga("ec:addProduct", {
				"id": item.id,
				"name": item.title,
				"price": item.promo_price && item.promo_price < item.price ? item.promo_price : item.price,
				"category": item.category.name,
				"quantity": 1
			});

			ga("ec:setAction", "add");
			ga("send", "event", "Cart", "Add to Cart", item.title);
		}

		// Push google tag event
		if (typeof gtag !== "undefined") {
			gtag('event', 'add_to_cart', {
				currency: "BGN",
				value: item.promo_price && parseFloat(item.promo_price) < parseFloat(item.price) ? item.promo_price : item.price,
				items: [
				{
					item_id: item.id,
					item_name: item.title,
					currency: "BGN",
					discount: item.promo_price ? (parseFloat(item.price) - parseFloat(item.promo_price)).toFixed(2) : 0,
					item_brand: item.manufacturer.name,
					item_category: item.category.name,
					price: item.price,
					quantity: 1,
					id: item.id,
					google_business_vertical: 'custom'
				}
				]
			});
		}

		// Push data layer event
		if (typeof dataLayer !== "undefined") {
			dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push({
				event: 'add_to_cart', 
				ecommerce: {
					currency: "BGN",
					value: item.promo_price && parseFloat(item.promo_price) < parseFloat(item.price) ? item.promo_price : item.price,
					items: [
					{
						item_id: item.id,
						item_name: item.title,
						discount: item.promo_price ? (parseFloat(item.price) - parseFloat(item.promo_price)).toFixed(2) : 0,
						item_brand: item.manufacturer.name,
						item_category: item.category.name,
						price: item.price,
						quantity: 1,
						id: item.id,
						google_business_vertical: 'custom'
					}
					]
				}
			});
		}
	}

	var trackProductRemove = function(item) {
		// Push google analytics events
		if (typeof ga !== "undefined") {
			ga("ec:addProduct", {
				"id": item.id,
				"name": item.title,
				"price": item.promo_price && item.promo_price < item.price ? item.promo_price : item.price,
				"category": item.category.name,
				"quantity": 1
			});

			ga("ec:setAction", "remove");
			ga("send", "event", "Cart", "Remove from Cart", item.title);
		}

		// Push google tag event
		if (typeof gtag !== "undefined") {
			gtag('event', 'remove_from_cart', {
				currency: "BGN",
				value: item.promo_price && parseFloat(item.promo_price) < parseFloat(item.price) ? item.promo_price : item.price,
				items: [
				{
					item_id: item.id,
					item_name: item.title,
					currency: "BGN",
					discount: item.promo_price ? (parseFloat(item.price) - parseFloat(item.promo_price)).toFixed(2) : 0,
					item_brand: item.manufacturer.name,
					item_category: item.category.name,
					price: item.price,
					quantity: 1
				}
				]
			});
		}

		// Push data layer event
		if (typeof dataLayer !== "undefined") {
			dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push({
				event: 'remove_from_cart',
				ecommerce: {
					currency: "BGN",
					value: item.promo_price && parseFloat(item.promo_price) < parseFloat(item.price) ? item.promo_price : item.price,
					items: [
					{
						item_id: item.id,
						item_name: item.title,
						discount: item.promo_price ? (parseFloat(item.price) - parseFloat(item.promo_price)).toFixed(2) : 0,
						item_brand: item.manufacturer.name,
						item_category: item.category.name,
						price: item.price,
						quantity: 1
					}
					]
				}
			});
		}
	}

	var trackCheckoutProcess = function() {
		var data = $(document.body).attr("data-track");

		if (data) {
			data = JSON.parse(data);

			// No ga data
			if (!data.ga) {
				return;
			}

			if (data.ga.event == "Checkout") {
				trackCheckout(data.ga);
			}

			if (data.ga.event == "Purchase") {
				trackPurchase(data.ga);
			}
		}
	}

	var trackCheckout = function(data) {
		var items = data.items;
		var total = 0;
		var ga4Items = items.map(item => {
			total += parseFloat(item.price);
			
			// Push google analytics event
			if (typeof ga !== "undefined") {
				ga("ec:addProduct", item);
			}

			return {
				item_id: item.id,
				item_name: item.name,
				index: item.position,
				item_brand: item.brand,
				item_category: item.category,
				price: item.price,
				quantity: item.quantity
			};
		});

		// Push google tag event
		if (typeof gtag !== "undefined") {
			gtag("event", "begin_checkout", {
				currency: "BGN",
				value: total,
				items: ga4Items
			});
		}

		// Push data layer event
		if (typeof dataLayer !== "undefined") {
			dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push({
				event: "begin_checkout", 
				ecommerce: {
					currency: "BGN",
					value: total,
					items: ga4Items
				}
			});
		}

		// Push google analytics event
		if (typeof ga !== "undefined") {
			ga("ec:setAction", "checkout", {
			"step": 1 // Always 1
			});
		}
	}

	var trackPurchase = function(data) {

		var items = data.items;
		var revenue = 0;

		var ga4Items = items.map(item => {
			// Push google analytics event
			if (typeof ga !== "undefined") {
				ga("ec:addProduct", item);
			}
			revenue += parseFloat(item.price);

			return {
				item_id: item.id,
				item_name: item.name,
				currency: "BGN",
				index: item.position,
				item_brand: item.brand,
				item_category: item.category,
				price: item.price,
				quantity: item.quantity,
				id: item.id,
				google_business_vertical: 'custom'
			};
		}); 

		if (data.shipping) {
			revenue += parseFloat(data.shipping);
		}

		// Push google analytics event
		if (typeof ga !== "undefined") {
			ga("ec:setAction", "purchase", {
				"id": data.id,
				"revenue": revenue,
				"shipping": data.shipping
			});
		}

		// Push google tag event
		if (typeof gtag !== "undefined") {
			gtag("event", "purchase", {
				transaction_id: data.id,
				value: revenue - parseFloat(data.shipping),
				shipping: parseFloat(data.shipping),
				currency: "BGN",
				items: ga4Items
			});
		}

		// Push data layer event
		if (typeof dataLayer !== "undefined") {
			dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
			dataLayer.push({
				event: "purchase", 
				ecommerce: {
					transaction_id: data.id,
					value: revenue - parseFloat(data.shipping),
					shipping: parseFloat(data.shipping),
					currency: "BGN",
					items: ga4Items
				}
			});
		}
	}

	var trackSearch = function(term) {
		
		if (typeof ga !== "undefined") {
			ga('send', 'pageview', '/search?term=' + term);
		}

		if (typeof gtag !== "undefined") {
			gtag("event", "search", {
				search_term: term
			});
		}

		if (typeof dataLayer !== "undefined") {
			dataLayer.push({
				event: "search", 
				search_term: term
			});
		}
	}

	var trackEcommerceHit = function() {
		// Do nothing if ga is not loaded
		if (typeof ga === "undefined") {
			return;
		}

		ga("send", {
			hitType: 'event',
			eventCategory: 'Ecommerce',
			eventAction: 'HIT',
			nonInteraction: true
		});
	}

	window.ECMT = {
		beforePageView: function() {
			trackDetail();
			trackImpressions();
			trackCheckoutProcess();

			CartItems.on("add", trackProductAdd);
			CartItems.on("remove", trackProductRemove);

			trackEcommerceHit();
		},

		trackImpressions: function(parent, lists) {
			trackImpressions(parent, lists);
		},

		trackSearch: function(term) {
			trackSearch(term);
		}
	}

})();